import Carousel from "react-multi-carousel";

import classes from "./CarouselSlider.module.css";
import "react-multi-carousel/lib/styles.css";

import { Movie } from "src/types/movieData";

import React from "react";
import MovieItem from "../MovieList/MovieItem";
import SeriesItem from "../SeriesList/SeriesItem";
import { TvShow } from "src/types/tvSeriesData";
import { Person } from "src/types/personData";
import PersonItem from "../PeopleList/PersonItem";

type Props = {
  movies?: Movie[];
  shows?: TvShow[];
  people?: Person[];
};

const CarouselSlider = ({ movies, shows, people }: Props) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 30000, min: 1000 },
      items: 3,
      slidesToSlide: 3,
    },
    laptop: {
      breakpoint: { max: 1100, min: 800 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 800, min: 600 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
      showDots: false,
    },
  };

  const renderCarousel = () => {
    if (movies) {
      return movies.map((movie) => <MovieItem movieData={movie} />);
    } else if (shows) {
      return shows.map((show) => <SeriesItem showsData={show} />);
    }
    return people && people.map((person) => <PersonItem personData={person} />);
  };

  return (
    <div>
      <Carousel
        responsive={responsive}
        infinite={true}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass={classes.carouselContainer}
        itemClass={classes.carouselItem}
        sliderClass={classes.carouselSlider}
      >
        {renderCarousel()}
      </Carousel>
    </div>
  );
};

export default CarouselSlider;
